import { KpiSheetColumn } from '../components/kpi-sheet/kpi-sheet-models';
import { IDefaultTableColumnConfig, IDualAxisLineGraphConfig, KpiSheetOptions, IMultiLevelDualAxisLineGraphConfig } from './config.models';
import { INameValuePair } from './models';

/*
 * service scheduler configs
 */
export interface IServiceSchedulerOverviewConfig {
  reportTitle: string;
  chartSeriesColors: string[];
  billboards: IServiceSchedulerOverviewBillboardConfig[];
  kpiSheetOptions: Record<KpiSheetOptions, KpiSheetColumn[]>;
  trendGraphConfig: IMultiLevelDualAxisLineGraphConfig;
  dealerTableColumns: IDefaultTableColumnConfig[];
  metricDisplayModes: INameValuePair[];
}

export interface IServiceSchedulerOverviewBillboardConfig {
  title: string;
  subtitle: string;
  subtitleOne?: string;
  subtitleTwo?: string;
  iconClass: string;
  reverseMetric: boolean;
  metricCurrentPropertyName: string;
  metricMOMPropertyName: string;
  metricYOYPropertyName: string;
  metricPreviousMonthPropertyName: string;
  metricPreviousMTDPropertyName: string;
  metricPreviousMTDDisplayOnCurrentMonth: boolean;
  metricPreviousMTDDisplayHistorical: boolean;
  metricPreviousMTDLabel: string;
  metricPreviousMonthDisplayOnCurrentMonth: boolean;
  metricPreviousMonthDisplayHistorical: boolean;
  metricPreviousMonthLabel: string;
  metricPreviousYearPropertyName: string;
  footerRowCount: number;
  footerTwoLeftLabel: string;
  footerTwoRightLabel: string;
  footerTwoMetricFormatKey: string;
  trendArrowDrivingPropertyName: string;
  metricFormatKey: string;
  helpTextKey: string;
  helpTextTitle: string;
}


export interface IServiceSchedulerOverviewKpiConfig {
  chartTitle: string;
  preCutoffChartTitle?: string;
  xAxisPropertyName: string;
  metrics: IServiceSchedulerTrendKpiConfig[];
}

export interface IServiceSchedulerTrendKpiConfig {
  displayName: string;
  propertyName: string;
  yAxisTitle: string;
  pointLabelFormat: string;
  metricFormatKey: string;
  formatter: (val: any) => {};
}
